<div [ngClass]="{
  'loading-container-select-client': isSelectClientPage && isLoading,
  'no-data-container-select-client': isSelectClientPage && !isLoading,
  'no-data-container': !isSelectClientPage
}">
  <mat-icon class="no-data-svg" [svgIcon]="isLoading ? 'loading-data' : 'table-no-data'"></mat-icon>
  @if (isLoading) {
    <h3 class="caption">Loading data...</h3>
  } @else {
    <h3 class="caption">No Data Found</h3>

    @if (showButton) {
      <button mat-raised-button (click)="redirectTo()">
        {{ buttonText }}
      </button>
    }
  }
</div>
